import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import styles from "./ChatPage.module.scss";
import Loader from "../../common/components/Loader";
import { Toaster, toast } from "react-hot-toast";
import Messages from "../../Modules/Messages";
import { fetchInformation } from "../../common/services/api.services";
import {
  API_ROUTES,
  FUNDING_GUEST_USER_ACCESS_TIMES,
  GUEST_USER_ACCESS,
  INITIAL_CHAT_DATAS,
  VERIFY_AUTHENTICATION_STATUS,
} from "../../common/constants";
import SideMenu from "../../Modules/SideMenu";
import Themes from "../../common/components/Themes";
import ChatWindowWrapper from "../../common/components/ChatWindowWrapper";
import ChatSearch from "../../common/components/ChatSearch";

const ChatPage = () => {
  const [searchparams] = useSearchParams();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [datas, setDatas] = useState(INITIAL_CHAT_DATAS);
  const GUEST_USER_LOGIN_INTIAL_ACCESS = 0;
  const [needSignIn, setNeedSignIn] = useState(GUEST_USER_LOGIN_INTIAL_ACCESS);
  const getContentsFromSearchBar = searchparams.get("query");
  const [inputValue, setInputValue] = useState("");

  const isAuthenticated = VERIFY_AUTHENTICATION_STATUS;

  const guestUserAccess = () => {
    if (!isAuthenticated) {
      setNeedSignIn((prev) => prev - 1);
    }
  };

  const onSubmit = async (inputValue: string) => {
    if (inputValue || getContentsFromSearchBar) {
      guestUserAccess();
      try {
        setLoader(true);
        const responses = await fetchInformation(
          inputValue,
          API_ROUTES.ASK_HOUZZ
        );
        const apiData = responses?.data;
        setDatas([{ id: 1, user: inputValue, response: apiData }]);
      } catch (e) {
        console.log(e);
        toast.error("Somthing went wrong, please try again");
      } finally {
        setLoader(false);
      }
    } else {
      toast.error("Please enter necessary input");
    }
  };

  const handleChangeChatSearch = (value: any) => {
    setInputValue(value);
  };

  const loggedIn = needSignIn > 0 || isAuthenticated;

  useEffect(() => {
    if (getContentsFromSearchBar) {
      onSubmit(getContentsFromSearchBar);
      setInputValue(getContentsFromSearchBar);
    }
    navigate(
      {
        pathname: "/chat",
      },
      { replace: true }
    );
  }, [searchparams]);

  useEffect(() => {
    if (!GUEST_USER_ACCESS) {
      localStorage.setItem("GUEST_USER_ACCESS", "true");
      setNeedSignIn(FUNDING_GUEST_USER_ACCESS_TIMES);
    }
  }, [GUEST_USER_ACCESS]);

  return (
    <Themes>
      <Toaster />
      <section className={styles.container}>
        <div className={styles.windowWrapper}>
          <div className={styles.desktopSideMenu}>
            <SideMenu />
          </div>

          <ChatWindowWrapper>
            <ChatSearch
              handleChangeChatSearch={handleChangeChatSearch}
              searchValue={inputValue}
              placeholder="Search your dream house"
              loader={loader}
              loggedIn={loggedIn}
              onSubmitFn={onSubmit}
            />
            {loader && <Loader />}
            <article>{!loader && <Messages contentArray={datas} />}</article>
          </ChatWindowWrapper>
        </div>
        <div className={styles.bottomSideMenu}>
          <SideMenu />
        </div>
      </section>
    </Themes>
  );
};

export default ChatPage;
